"use client";

import { trans } from "@/service/i18n/i18n";
import { PictureAsset } from "@/components/common/picture-asset";
import { getAssetImage } from "@/service/image/asset";
import { ArrowUpRightIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { createPath } from "@/service/routing/routing";

export const ChooseExamTypeBlock = ({
  examType,
  isLogout = false,
  customAction,
}: {
  examType: ExamTypeId;
  isLogout?: boolean;
  customAction?: () => void;
}) => {
  const [isHover, setHover] = useState(false);
  const illustrations = {
    1: "stetho",
    2: "hat",
    3: "teeth",
  };

  return (
    <div
      className={cn(
        "relative flex h-[288px] w-[288px] flex-col justify-end overflow-hidden rounded-xl border p-6 transition-all hover:cursor-pointer",
        examType === 1 && "bg-remedium-orange border-remedium-orange/18",
        examType === 2 && "bg-remedium-blue border-remedium-blue/18",
        examType === 3 && "border-teal-700/18 bg-teal-700",
        !isHover && examType === 1 && "bg-remedium-orange/8",
        !isHover && examType === 2 && "bg-remedium-blue/8",
        !isHover && examType === 3 && "bg-teal-700/8",
      )}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={customAction}
    >
      {!customAction && (
        <a
          className={"absolute top-0 left-0 z-100 h-full w-full"}
          href={
            isLogout
              ? createPath("security.login")
              : examType === 1
              ? createPath("exam.pes_choose_specialization")
              : createPath("exam.index", {
                  examType: 2,
                })
          }
        />
      )}

      <div
        className={cn(
          "absolute translate-x-4 translate-y-2 opacity-40 grayscale-100 transition-all",
          !isHover && "translate-y-4 opacity-20",
          examType === 1 &&
            "top-[10px] -right-[80px] h-[294px] w-[294px] -rotate-32",
          examType === 2 &&
            "top-[21px] -right-[10px] h-[137px] w-[230px] -rotate-18",
          examType === 3 && "-top-[20px] right-[15px] h-[137px] w-[230px]",
        )}
      >
        <PictureAsset
          source={getAssetImage(
            `/exams/choose-setup/${illustrations[examType]}`,
          )}
          ext={"png"}
          alt={"ilustracja"}
        />
      </div>

      <div className={"relative z-10"}>
        <h2
          className={cn(
            `text-colors-base-black text-lg font-semibold transition-all`,
            isHover ? "text-white" : "text-black",
          )}
        >
          Egzamin {trans(`exams.title.short.${examType}`)}
        </h2>
        <div className={"flex items-end justify-between gap-8"}>
          <p
            className={cn(
              `text-colors-base-black text-sm font-medium transition-all`,
              isHover ? "text-white" : "text-black",
            )}
          >
            {trans(`exams.title.long.${examType}`)}
          </p>
          <ArrowUpRightIcon
            size={16}
            className={cn(
              "min-w-4 transition-all",
              isHover ? "stroke-white" : "stroke-black",
            )}
          />
        </div>
      </div>
    </div>
  );
};
